import { Box, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../../section-title/section-title.component';
import Timelines from './timelines/timelines.component';

const TimelineSection = ({ transaction }) => {
  const { t } = useTranslation();
  const { events = [], chargeAmount, currency } = transaction ?? {};

  return (
    <Box>
      <SectionTitle title={t('drawer.transactionDrawer.timeline.title')} />
      <Stack spacing={1}>
        {events.map(event => (
          <Timelines
            event={event}
            key={event.createdDate}
            chargeAmount={chargeAmount}
            currency={currency}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default TimelineSection;
